import AddIcon from '@mui/icons-material/Add';
import React, { useContext } from 'react';
import { AzureSearchServiceHeaderToolbarProps } from '../Model/AzureSearchServiceProps';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import PermissionConstants from '../../../Common/Constants/PermissionConstants';
import { Link } from 'react-router-dom';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';
import SearchBar from '../../../../Common/Components/Controls/SearchBar';
import CustomButton from '../../../../Common/Components/Controls/InputControls';

const AzureSearchServiceHeaderToolbar = ({
  onFilterRequest,
}: AzureSearchServiceHeaderToolbarProps) => {
  const permissions = useContext(PermissionsContext);
  const hasAzureSearchServiceWritePermission =
    permissions[PermissionConstants.AzureSearchServiceWriter];

  return (
    <HeaderToolbar
      leftContent={<SearchBar onChange={onFilterRequest} width="35%" />}
      rightContent={
        hasAzureSearchServiceWritePermission && (
          <CustomButton
            startIcon={<AddIcon />}
            component={Link}
            to="/SearchService/create"
            label="Add"
          />
        )
      }
    />
  );
};

export default AzureSearchServiceHeaderToolbar;
